/**
 * Show/hide follow-up panels based on selected main answers (per question section).
 */

export function syncFollowUpVisibility(section) {
  const blocks = section.querySelectorAll(
    ".product-selector-page__question-follow-ups .follow-up[data-parent-answer-index]"
  );

  for (let b = 0; b < blocks.length; b++) {
    const block = blocks[b];
    const parentIdx = block.getAttribute("data-parent-answer-index");

    if (parentIdx === null || parentIdx === "") {
      continue;
    }

    const checked = section.querySelector(
      'input[data-ps-main][data-answer-index="' + parentIdx + '"]:checked'
    );

    if (checked) {
      block.removeAttribute("hidden");
    } else {
      block.setAttribute("hidden", "");
    }
  }
}

export function findFollowUpChecked(section, answerIndex) {
  return section.querySelector(
    'input[data-ps-follow-up][data-parent-answer-index="' +
      String(answerIndex) +
      '"]:checked'
  );
}

export function syncAllFollowUpVisibility(root) {
  const sections = root.querySelectorAll(".product-selector-page__question");

  for (let i = 0; i < sections.length; i++) {
    syncFollowUpVisibility(sections[i]);
  }
}
